export default __webpack_public_path__ + "static/media/logo.071dd4b9.png";